import { Checkbox } from 'antd';

import { CoverCellRoom } from 'app/components/lists/cells';
import { useGetRoomsByHotelId } from 'app/hooks/data/core/admin/hotels/useHotelRooms';
import { useRoomCategories } from 'app/hooks/data/rooms/useRoomCategories';
import type { HotelRoomResponse } from 'app/typings/core/admin/rooms/room';
import { capitalizeFirstLetter } from 'app/utils/string';

import './AddRoomsModal.scss';

type RoomListItemProps = {
  room: HotelRoomResponse;
  selected: boolean;
  onToggle: (id: number, checked: boolean) => void;
};

export const RoomListItem = ({
  room,
  selected,
  onToggle,
}: RoomListItemProps) => {
  const { data: hotelRooms } = useGetRoomsByHotelId(room.hotelId);
  const { data: roomCategories } = useRoomCategories();

  const selectedRoom = hotelRooms?.rooms.find((r) => r.id === room.id);
  const roomCategory = roomCategories?.find(
    // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
    (roomCategory) => roomCategory.id === room?.categoryId
  );

  const firstPicture = selectedRoom?.pictures[0];
  const coverPicture = firstPicture
    ? {
        id: firstPicture.id,
        createdAt: firstPicture.updatedAt
          ? new Date(firstPicture.updatedAt)
          : new Date(),
        updatedAt: firstPicture.updatedAt
          ? new Date(firstPicture.updatedAt)
          : new Date(),
        path: firstPicture.path,
        dimensions: firstPicture.dimensions,
      }
    : undefined;

  return (
    <div className="room-list-item">
      <div className="room-info">
        <CoverCellRoom
          category={roomCategory?.name ?? ''}
          entity={{
            coverPicture,
            name: selectedRoom?.name,
          }}
        />
      </div>
      <div className="room-status">
        <span className={`er-dot ${room.status.toLowerCase()}`} />
        <span className="status-text">
          {capitalizeFirstLetter(room.status)}
        </span>
      </div>
      <div className="room-action">
        <Checkbox
          checked={selected}
          onChange={(e) => onToggle(room.id, e.target.checked)}
        />
      </div>
    </div>
  );
};
